/**
 *
 * LoginComponent
 *
 */

import React from "react"
import PropTypes from "prop-types"
// import styled from 'styled-components';

import { Input, Button, Checkbox, Avatar, message } from "antd"
import "./index.less"
import { Link } from "react-router-dom"
import { ExclamationOutlined } from "@ant-design/icons"
import SeparatorLogin from "../../images/separator-login.svg"
import GoogleLogo from "../../images/google.svg"
import Office365logo from "../../images/office365.svg"
import {
  KEY_REMEMBER_PASSWORD,
  LOCAL_REMEMBER_PASSWORD,
  setItem,
} from "../../utils/storage"
import ReCAPTCHA from "react-google-recaptcha"
import { loadTextsLocalStorage } from "../../utils/i18n"

/* eslint-disable react/prefer-stateless-function */
class LoginComponent extends React.Component {
  constructor() {
    super()
    this.state = {
      email: "",
      password: "",
      error: false,
      remember: false,
      disabled: false,
      logoLoaded: false,
    }

    this.refCaptchaBadge = React.createRef()
    this.intl = loadTextsLocalStorage("login")
  }

  componentDidMount() {
    const rememberPwd = JSON.parse(LOCAL_REMEMBER_PASSWORD())

    if (rememberPwd) {
      if (rememberPwd.remember) {
        this.setState(rememberPwd)
      }
    }
  }

  handleSubmit = async () => {
    this.rememberPass()

    const recaptchaEnabled = process.env.CAPTCHA_FEATURE_FLAG == 1
    let recaptchaToken = null

    if (recaptchaEnabled) {
      recaptchaToken = await this.refCaptchaBadge.current.executeAsync()

      if (!recaptchaToken) {
        message.error("Error en ReCaptcha")
        return
      }
    }

    const payload = {
      email: this.state.email,
      password: this.state.password,
      remember: this.state.remember,
      recaptchaToken,
    }

    this.props.login(payload)

    if (recaptchaEnabled) this.refCaptchaBadge.current.reset()
  }

  rememberPass = () => {
    const { email, password, remember } = this.state

    const save_login = { email, password, remember }
    setItem(KEY_REMEMBER_PASSWORD, JSON.stringify(save_login))
  }

  validate = () => {
    const { email, password } = this.state
    if (email.length > 0 && password.length > 0) {
      this.setState({ disabled: false })
    } else {
      this.setState({ disabled: true }, () => {
        this.props.reset()
      })
    }
  }

  nameRef = React.createRef()

  onAutofill = () => {
    if (this.nameRef.current.input.value) return true

    this.setState({ disabled: true })
  }

  render() {
    const form = () => (
      <form>
        <div className="loginformContainer">
          <Input
            placeholder="Username"
            value={this.state.email}
            name="name"
            ref={this.nameRef}
            id="name"
            type="email"
            className="loginInput"
            onAnimationStart={this.onAutofill}
            onPressEnter={this.handleSubmit}
            onChange={(e) => {
              this.setState({ email: e.target.value }, () => {
                this.validate()
              })
            }}
          />
          <Input
            name="password"
            type="password"
            value={this.state.password}
            placeholder="Password"
            onPressEnter={this.handleSubmit}
            onChange={(e) => {
              this.setState({ password: e.target.value }, () => {
                this.validate()
              })
            }}
          />
          <div className="loginCheck">
            <Checkbox
              onChange={(event) =>
                this.setState({ remember: event.target.checked })
              }
              checked={this.state.remember}>
              {this.intl.loginForm.rememberMe}
            </Checkbox>
            <Link to="/forgottenPassword">{this.intl.loginForm.forgotPassword}</Link>
          </div>
          {process.env.CAPTCHA_FEATURE_FLAG == 1 && (
            <ReCAPTCHA
              sitekey={process.env.GOOGLE_CAPTCHA_KEY_V3}
              size="invisible"
              badge="inline"
              ref={this.refCaptchaBadge}
            />
          )}
          <Button
            className="button-signin"
            onClick={this.handleSubmit}
            size="large"
            // disabled={this.state.disabled}
            loading={this.props.loading}>
            {this.intl.loginForm.enter}
          </Button>
          <div
            className="loginCheck"
            style={{
              justifyContent: "center",
              gridGap: "0",
              margin: "1rem 0 0 0",
            }}>
            <img src={SeparatorLogin} />
          </div>
          <Button
            style={{ color: "#4F4F4F" }}
            onClick={() => {
              window.location.href = `${process.env.API_URL}oauth/google-login`
            }}>
            <img src={GoogleLogo} style={{ marginBottom: "5px" }} />
            &nbsp;&nbsp;&nbsp; {this.intl.loginForm.googleLogin}
          </Button>
          <Button
            style={{ color: "#4F4F4F" }}
            onClick={() => {
              window.location.href = `${process.env.API_URL}oauth/azure-login`
            }}>
            <img src={Office365logo} style={{ marginBottom: "5px" }} />
            &nbsp;&nbsp;&nbsp; {this.intl.loginForm.officeLogin}
          </Button>
        </div>
      </form>
    )
    return (
      <div className="loginContainerC">
        {this.props.errorExceed ? (
          <div className="errorMessage">
            <div className="circle">
              <ExclamationOutlined />
            </div>
            <p style={{ color: "white" }}>{this.props.errorMessage}</p>
          </div>
        ) : null}
        <div className="loginForm">
          <img
            onLoad={() => {
              this.setState({ logoLoaded: true })
            }}
            src={this.props.img}
            className="logoLogin"
          />
          {this.state.logoLoaded ? form() : <div />}
        </div>
      </div>
    )
  }
}

LoginComponent.propTypes = {
  reset: PropTypes.func.isRequired,
  login: PropTypes.func.isRequired,
}

export default LoginComponent
